// components/Composite/ManualTable/ManualTable.js
import React from 'react';
import PropTypes from 'prop-types';
import { RawHtml } from '../../Utilities';

const TAG_STYLES = {
  high:   'bg-red-100 text-red-800',
  medium: 'bg-amber-100 text-amber-800',
  low:    'bg-blue-100 text-blue-800',
};

const formatNumber = (num) =>
  num != null ? num.toLocaleString('en-US', { maximumFractionDigits: 0 }) : null;

const formatPrice = (number, numberTo, currencySign) => {
  const currency = currencySign ? currencySign.toUpperCase() : '';
  const from = formatNumber(number);
  const to   = formatNumber(numberTo);

  if (from && to) return `${currency} ${from} – ${to}`.trim();
  if (from)       return `${currency} ${from}`.trim();
  return null;
};

const ManualTable = ({ value = {} }) => {
  const { caption, rows = [] } = value;

  if (!rows.length) return null;

  return (
    <section className="section section-full">
      <div className="section__inner">

        {caption && (
          <div className="section__header">
            <div className="text-section-title">{caption}</div>
          </div>
        )}

        <div className="section__body">
          <div className="grid-2 gap-blocks">
            {rows.map((row, index) => {
              const price = formatPrice(row.number, row.numberTo, row.currencySign);
              const tags  = row.tags || [];

              return (
                <div key={index} className="card card-data surface-pad-normal">
                  <div className="flex flex-col gap-xs">

                    {/* Row 1: title + price on same line */}
                    <div className="cluster cluster-between">
                      <div className="text-item-title">{row.title}</div>
                      {price && (
                        <div className="text-item-title">{price}</div>
                      )}
                    </div>

                    {/* Row 2: tags */}
                    {tags.length > 0 && (
                      <div className="cluster cluster-tight">
                        {tags.map((tag, i) => (
                          <span
                            key={i}
                            className={`status normal-case ${TAG_STYLES[tag.importance] || TAG_STYLES.medium}`}
                          >
                            {tag.label.charAt(0).toUpperCase() + tag.label.slice(1).toLowerCase()}
                          </span>
                        ))}
                      </div>
                    )}

                    {/* Row 3: remark */}
                    {row.remark && (
                      <div className="text-label text-muted">{row.remark}</div>
                    )}

                    {/* Row 4: description */}
                    {row.description && (
                      <div className="text-body-sm">
                        <RawHtml html={row.description} />
                      </div>
                    )}

                  </div>
                </div>
              );
            })}
          </div>
        </div>

      </div>
    </section>
  );
};

ManualTable.propTypes = {
  value: PropTypes.shape({
    caption: PropTypes.string,
    rows: PropTypes.arrayOf(
      PropTypes.shape({
        title:        PropTypes.string,
        description:  PropTypes.string,
        type:         PropTypes.string,
        currencySign: PropTypes.string,
        number:       PropTypes.number,
        numberTo:     PropTypes.number,
        remark:       PropTypes.string,
        tags:         PropTypes.arrayOf(
          PropTypes.shape({
            label:      PropTypes.string,
            importance: PropTypes.string,
          })
        ),
      })
    ),
  }),
};

export default ManualTable;